export class BlockCardReason {
  constructor(private readonly name: string, private readonly localizedName: string) {}

  getName(): string {
    return this.name;
  }

  getLocalizedName(): string {
    return this.localizedName;
  }
}
